module.exports = __webpack_public_path__ + "static/img/login_schools.6b48309.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/login_schools.png
// module id = KBNo
// module chunks = 37